export default "__VITE_ASSET__7a92dd12__"